/**
 * Settings → Subscription tab.
 *
 * Thin wrapper around <SubscriptionPage /> so Owner/Admin can upgrade or
 * cancel their SaaS plan without leaving Settings. The full page at
 * `/billing/subscription` remains for direct-linked flows (e.g. the
 * Dashboard's Plan & Usage widget and the Trial-expiring banner CTAs).
 */
import SubscriptionPage from "@/pages/SubscriptionPage";

export default function SubscriptionTab() {
  return <SubscriptionPage />;
}
